import styled from 'styled-components';
import { styleVariables } from '../../../common/constants';

const SecondaryNavigationRootElement = styled.div`
    width: 100%;
    background: #161616;
    padding: 0;
    position: sticky;
    top: -1px;
    z-index: 1301;
    height: 56px;
    box-sizing: border-box;
    .secondary-navigation {
        display: flex;
        align-items: center;
        height: 56px;
        .left {
            width: 70%;
            .title {
                color: ${styleVariables.primitivesColor.primary.white};
                font-size: 15px;
                font-weight: ${styleVariables.primitivesFontWeights.emphasized};
            }
            .backTitle {
                cursor: pointer;
                display: flex;
                svg {
                    width: 24px;
                    margin-right: 5px;
                    flex: none;
                }
            }
        }
        .right {
            width: 30%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color: ${styleVariables.primitivesColor.primary.white};
            .tooltip-icon-typography {
                color: ${styleVariables.primitivesColor.primary.white};
                position: relative;
                top: 3px;
                cursor: pointer;
            }
            svg {
                width: 20px;
            }
            .translate-button {
                background: #161616;
                color: ${styleVariables.primitivesColor.primary.white};
                font-size: ${styleVariables.primitivesFontSize['2']};
                font-weight: 600;
                border: none;
                box-shadow: none;
                margin-left:5px;
                .MuiSelect-select {
                    padding: 0 27px 0 0;
                    &::before {
                        box-shadow: none;
                    }
                    @media (max-width: 767px) {
                        padding: 0 18px 0 0;
                    }
                }
                svg {
                    margin-right: 0px;
                    right: 0;
                    color: ${styleVariables.primitivesColor.primary.white};
                }
            }
        }
    }
`;
export default SecondaryNavigationRootElement;
